import { Pipe } from '@angular/core';
import { extractDeepPropertyByMapKey, isObject, isUndefined } from '../helpers/helpers';
var UniquePipe = (function () {
    function UniquePipe() {
    }
    UniquePipe.prototype.transform = function (input, propertyName) {
        var uniques = [];
        return Array.isArray(input) ?
            isUndefined(propertyName) ?
                input.filter(function (e, i) { return input.indexOf(e) === i; }) :
                input.filter(function (e, i) {
                    var value = extractDeepPropertyByMapKey(e, propertyName);
                    value = isObject(value) ? JSON.stringify(value) : value;
                    if (isUndefined(value) || uniques[value]) {
                        return false;
                    }
                    uniques[value] = true;
                    return true;
                }) : input;
    };
    UniquePipe.decorators = [
        { type: Pipe, args: [{ name: 'unique' },] },
    ];
    /** @nocollapse */
    UniquePipe.ctorParameters = function () { return []; };
    return UniquePipe;
}());
export { UniquePipe };
//# sourceMappingURL=unique.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/array/unique.js
// module id = 237
// module chunks = 4